export const formatPackPrice = (value: number, trimDecimal?: boolean) =>
  trimDecimal ? `$${Math.floor(value)}` : `$${value.toFixed(2)}`;

export const getFormulaPriceInfo = (
  originalPrice: number,
  monthlyPrice: number,
  offerDuration?: string,
) => ({
  displayMonthlyPrice: monthlyPrice.toFixed(2),
  greenDaily: (monthlyPrice / 30).toFixed(2),
  strikethroughDaily:
    monthlyPrice < originalPrice ? (originalPrice / 30).toFixed(2) : null,
  isPriceAvailable: true,
  hasDiscount: monthlyPrice < originalPrice,
  monthlyPriceWithOutDiscount: originalPrice.toFixed(2),
  offerDuration,
});

/** Apply amount discounts before percentage discounts, then round to cents. */
export const getDiscountedPrice = (
  originalPrice: number,
  discountAmount = 0,
  discountPercentage = 0,
) => {
  const hasDiscount = discountAmount > 0 || discountPercentage > 0;
  let discountedPrice = originalPrice;

  if (hasDiscount) {
    if (discountAmount > 0) {
      discountedPrice = Math.max(0, originalPrice - discountAmount);
    } else if (discountPercentage > 0) {
      discountedPrice = originalPrice * (1 - discountPercentage / 100);
    }
  }

  return {
    originalPrice,
    discountedPrice: Math.round(discountedPrice * 100) / 100,
    hasDiscount,
  };
};
